module.exports = __webpack_public_path__ + "img/reeducacao@2x.5d34dda4.jpeg";